import { CreateCategoryPayload, UpdateCategoryPayload } from '@models/payload/category';

import { MenuCategory } from '@models/response/category';
import { MenuItemDto } from '@models/ropolo';
import { ActionReducerMapBuilder, PayloadAction, createSlice } from '@reduxjs/toolkit';
import categoryService from '@services/category';

// eslint-disable-next-line import/no-cycle
import { createAppAsyncThunk } from '../utils/reduxUtil';

type MenuCategoryWithMenuItem = MenuCategory & {
  menuItems: MenuItemDto[];
};

interface CategoryState {
  items: MenuCategoryWithMenuItem[];
  loading: boolean;
}

const initialState: CategoryState = {
  items: [],
  loading: false,
};

const syncCategoryWithSnappFood = createAppAsyncThunk<void, string>(
  'category/syncCategoryWithSnappFood',
  async (input) => {
    const response = await categoryService.syncBySnappFood(input);
    return response;
  }
);

const categorySlice = createSlice({
  name: 'category',
  initialState,

  reducers: {
    setCategories: (state, action: PayloadAction<CategoryState>) => ({
      ...state,
      items: action.payload.items,
    }),
  },
  extraReducers: (builder: ActionReducerMapBuilder<CategoryState>) => {
    builder.addCase(syncCategoryWithSnappFood.pending, (state) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(syncCategoryWithSnappFood.fulfilled, (state) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(syncCategoryWithSnappFood.rejected, (state) => ({
      ...state,
      loading: false,
    }));
  },
});

const createCategory = createAppAsyncThunk<void, CreateCategoryPayload>('category/createCategory', async (input) => {
  const response = await categoryService.createCategory(input);
  return response;
});

const updateCategory = createAppAsyncThunk<void, UpdateCategoryPayload>('category/updateCategory', async (input) => {
  const response = await categoryService.updateCategory(input);
  return response;
});

const changeCategoryActivation = createAppAsyncThunk<void, string>(
  'category/changeCategoryActivation',
  async (input) => {
    const response = await categoryService.changeCategoryActivation(input);
    return response;
  }
);

export default categorySlice;
export { changeCategoryActivation, createCategory, syncCategoryWithSnappFood, updateCategory };
